// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/required/required.js#1 $
'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcRequired
* @element ANY
* @description
* directive that observes when the required attribute (from ngRequired) changes 
*  and fires to the component scope (to expand the accordion that contains the element)
*/
angular.module('tcApp')
.directive('tcRequired', function($timeout) {
	return {
		restrict: 'A',
		require: ['^?ngModel','^?form'],
		link: function(scope, element, attrs, controllers) {
			var modelController = controllers[0];
			var formController = controllers[1];
			if (!formController) {
				return;
			}
			if (!modelController) {
				//custom template item may or may not be bound to a controller
				return;
			}
			
			attrs.$observe('required', function(value) {
				// wrap in timeout to allow the $error to take into affect.
				$timeout(function updateItem() {
					scope.$emit('Component:updateDataItemRequired', modelController.$name, value, formController);
				});
			});
		}
	};
});
